import React, {useEffect, useState} from 'react';
import {
  PostAdd as PostAddIcon,
  FormatListNumbered as FormatListNumberedIcon,
  Person as PersonIcon,
  PlaylistAdd as PlaylistAddIcon,
  PersonAdd as PersonAddIcon,
} from '@material-ui/icons';
import {logout} from 'util/Authentication';
import Navigation from 'navigation/components/Navigation';
import {getQuickSightSignInToken, getUser} from 'UserLobby/service/UserService';

const quickSightEndpoints = {
  perth:
    'https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/8bef387f-039c-4820-a25a-400847acaf55',
  indy: 'https://us-east-2.quicksight.aws.amazon.com/sn/dashboards/2e37e97c-80a0-4285-a37b-9a5905f722dd',
};

export default function NavigationView(props) {
  const navTransitions = [
    {
      name: 'Procedure Lobby',
      path: '/Procedures',
      icon: <FormatListNumberedIcon />,
      authorities: ['ROLE_ADMIN'],
    },
    {
      name: 'Import Projects',
      path: '/Projects/import',
      icon: <PostAddIcon />,
      authorities: ['ROLE_ADMIN'],
    },
    {
      name: 'Import Procedures',
      path: '/Procedures/import',
      icon: <PlaylistAddIcon />,
      authorities: ['ROLE_ADMIN'],
    },
    {
      name: 'User Lobby',
      path: '/Users',
      icon: <PersonIcon />,
      authorities: ['ROLE_ADMIN'],
    },
    {
      name: 'Create User',
      path: '/Users/create',
      icon: <PersonAddIcon />,
      authorities: ['ROLE_ADMIN'],
    },
  ];
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = async (region) => {
    handleCloseDrawer();
    setDialogOpen(true);
    await navigateToQuickSight(region);
    handleCloseDialog();
  };
  const handleCloseDialog = () => setDialogOpen(false);
  const [user, setUser] = useState({
    firstName: 'Unknown',
    lastName: 'User',
  });

  useEffect(() => {
    handleRetrieveUser();
  }, []);

  const handleRetrieveUser = async () => {
    setUser(await getUser());
  };
  const handleOpenDrawer = () => setDrawerOpen(true);
  const handleCloseDrawer = () => setDrawerOpen(false);
  const navigateToQuickSight = async (region) => {
    const {SigninToken} = await getQuickSightSignInToken();
    const thisUrlEncoded = encodeURIComponent(`https://${window.location.hostname}`);
    const quicksightUrlEncoded = encodeURIComponent(quickSightEndpoints[region]);
    const quickSightSSO = `https://signin.aws.amazon.com/federation?Action=login&Issuer=${thisUrlEncoded}&Destination=${quicksightUrlEncoded}&SigninToken=${SigninToken}`;

    window.open(quickSightSSO, '_blank');
    setUser(user);
  };

  return (
    <Navigation
      {...props}
      user={user}
      navTransitions={navTransitions}
      dialogOpen={dialogOpen}
      drawerOpen={drawerOpen}
      onOpenDrawer={handleOpenDrawer}
      onCloseDrawer={handleCloseDrawer}
      onOpenDialog={handleOpenDialog}
      onCloseDialog={handleCloseDialog}
      onLogout={logout}
    />
  );
}
